import API, { graphqlOperation } from '@aws-amplify/api'
import dayjs from 'dayjs'
import loader from './loader'

export const ACTION = {
  AGGREGATE_MEASUREMENTS: 'dashboard-aggregate-measurements',
  GET_DAILY_RAINFALL: 'dashboard-get-daily-rainfall',
  GET_METRIC_SUMMARIES: 'dashboard-get-metric-summaries'
}

export const LOAD = { ...ACTION }

export const getAggregateMeasurements = (buildingId, floorId, areaId, debug = false) => {
  const from = dayjs().subtract(7, 'days').unix()
  const to = dayjs().unix()
  const fromPrev = dayjs().subtract(14, 'days').unix()
  const toPrev = from

  const query = `
    query ($fromPrev: Int!, $toPrev: Int!, $from: Int!, $to: Int!, $buildingId: [Int!], $floorId: [Int!], $areaId: [Int!], $debug: Boolean) {
      previous: getAggregateMeasurements (from: $fromPrev, to: $toPrev, buildingId: $buildingId, floorId: $floorId, areaId: $areaId, workhours: true, only: ["workspaceUtilization", "meetingUtilization"], aggregateOn: "mean", fn: "mean") {
        workspaceUtilization
        meetingUtilization
      }

      aggregateMeasurements: getAggregateMeasurements (from: $from, to: $to, buildingId: $buildingId, floorId: $floorId, areaId: $areaId, workhours: true, aggregateOn: "mean", fn: "mean") {
        workspaceUtilization
        meetingUtilization
        co2
        tvoc
        temp
        humidity
        lux
        mic
        massPm10
        massPm25
        soilTemp
        soilMoisture
        surfaceHumidity
        surfaceTemp
        tds
        ph
        conductivity
      }

      offlineCount: getOfflineDeviceCount (buildingId: $buildingId, floorId: $floorId, areaId: $areaId, debug: $debug) {
        pebbleOnline
        pebbleOffline
        abacusOnline
        abacusOffline
        docOnline
        docOffline
        airlabOnline
        airlabOffline
        pointgrabOnline
        pointgrabOffline
      }

      batteryLevel: getBatteryLevelOverview (buildingId: $buildingId, floorId: $floorId, areaId: $areaId) {
        low
        devices
        chargeDate
      }
    }
  `

  return loader.load(LOAD.AGGREGATE_MEASUREMENTS, (dispatch) => {
    return API.graphql(graphqlOperation(query, { from, to, fromPrev, toPrev, buildingId, floorId, areaId, debug }))
      .then((result) => dispatch({
        type: ACTION.AGGREGATE_MEASUREMENTS,
        ...result.data
      }))
  })
}

export const getMetricSummaries = (buildingId, floorId, areaId, companyId) => {
  const from = dayjs().subtract(7, 'days').unix()
  const to = dayjs().unix()
  const query = `
  query($from: Int!, $to: Int!, $buildingId: [Int!], $floorId: [Int!], $areaId: [Int!], $companyId: Int!) {
    getMetricSummaries(from: $from, to: $to, buildingId: $buildingId, floorId: $floorId, areaId: $areaId, companyId: $companyId) {
      metric
      mean
      max
      min
      sum
    }
  }
  `

  return loader.load(LOAD.GET_METRIC_SUMMARIES, (dispatch) => {
    return API.graphql(graphqlOperation(query, { from, to, buildingId, floorId, areaId, companyId }))
      .then((result) => dispatch({
        type: ACTION.GET_METRIC_SUMMARIES,
        ...result.data
      }))
  })
}
export const getDailyRainfall = (buildingId, floorId, areaId) => {
  const from = dayjs().subtract(7, 'days').unix()
  const to = dayjs().unix()
  const query = `
  query ($from: Int!, $to: Int!, $buildingId: [Int!], $floorId: [Int!], $areaId: [Int!]){
    dailyRainfall: getDailyRainfall (from: $from, to: $to, buildingId: $buildingId, floorId: $floorId, areaId: $areaId) {
      mean
      max
      maxDay {
        time
        value
        hourly {
          time
          value
        }
      }
      daily{ 
        mean 
        max
        sum 
        weekDay
      }
      areas{ 
        mean {
          rainfall 
          areaId
        } 
        max {
          rainfall 
          areaId
        }
      }
    }
    rainfallHour: getMeasurements (from: ${from}, to: ${to}, buildingId: $buildingId, floorId: $floorId, areaId: $areaId, groupBy: "FIFTEEN_MINUTES", fill: false, fn: "sum"){
      time
      rainfall
    }
  }`
  return loader.load(LOAD.GET_DAILY_RAINFALL, (dispatch) => {
    return API.graphql(graphqlOperation(query, { from, to, buildingId, floorId, areaId }))
      .then((result) => dispatch({
        type: ACTION.GET_DAILY_RAINFALL,
        ...result.data
      }))
  })
}
export const reducer = (state = {}, action) => {
  // eslint-disable-next-line
  const { type, ...rest } = action

  switch (type) {
    case ACTION.AGGREGATE_MEASUREMENTS:
      return {
        ...state,
        aggregateMeasurements: rest.aggregateMeasurements[0],
        previous: rest.previous[0],
        offlineCount: rest.offlineCount,
        batteryLevel: rest.batteryLevel
      }
    case ACTION.GET_DAILY_RAINFALL:
      return {
        //I want to use the sum instead of the mean in the daily rainfall
        ...state,
        dailyRainfall: {
          ...rest.dailyRainfall,
          rainfall: rest.rainfallHour,
          rainfallHour: rest.rainfallHour
        }
      }
    case ACTION.GET_METRIC_SUMMARIES: {
      const sumMetrics = ['rainfall']
      const summaries = (rest.getMetricSummaries || []).reduce((acc, item) => {
        const isSumVariant = item.metric.endsWith('_sum')
        const isMeanVariant = item.metric.endsWith('_mean')
        if (isSumVariant) {
          const key = item.metric.replace('_sum', '')
          if (sumMetrics.includes(key)) acc[key] = item.sum
        } else if (isMeanVariant) {
          const key = item.metric.replace('_mean', '')
          if (!sumMetrics.includes(key)) acc[key] = item.mean
        }
        return acc
      }, {})
      return {
        ...state,
        metricSummaries: summaries
      }
    }
    default:
      return state
  }
}
